<template>
  <div class="search-bar">
    <input
      ref="searchInput"
      type="text"
      autocomplete="off"
      name="q"
      :placeholder="placeholderText"
      :aria-label="ariaLabel"
      :value="query"
      @input="changeInput($event.target.value)"
      @focus="setFocus"
      @keyup.enter="submit"
    />
    <button
      v-show="hasFocus"
      type="button"
      class="close-button"
      @click="clearQuery"
    />
    <button
      :class="{ 'is-hidden-mobile': hasFocus }"
      :aria-label="ariaLabel"
      type="submit"
      class="search-button"
      @click.prevent="submit"
    />
  </div>
</template>

<script>
export default {
  name: 'SearchBar',
  props: {
    /**
     * Initial input field value
     *
     * @type {string}
     */
    initialQuery: {
      type: String,
      default: ''
    },
    /**
     * Input field placeholder text
     *
     * @type {string}
     */
    placeholderText: {
      type: String,
      default: 'What are you looking for?'
    },
    /**
     * Input field aria label
     *
     * @type {string}
     */
    ariaLabel: {
      type: String,
      default: 'Search'
    },
    /**
     * is Search Bar has been focused?
     *
     * @type {boolean}
     */
    isActive: {
      type: Boolean,
      default: false
    },
    /**
     * is user scrolling the search result?
     *
     * @type {boolean}
     */
    isScrolling: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      query: this.initialQuery,
      hasFocus: false,
      inputHasFocus: false
    }
  },
  watch: {
    isActive(value) {
      if (value) {
        this.setFocus()
      } else {
        this.unsetFocus()
      }
    },
    isScrolling(value) {
      if (value) {
        this.blurSearchInput()
      }
    }
  },
  methods: {
    setFocus() {
      this.hasFocus = true
      this.$emit('has-focus', this.hasFocus)
    },
    unsetFocus() {
      this.hasFocus = false
      this.$emit('has-focus', this.hasFocus)
    },
    clearQuery() {
      this.query = ''
      this.changeInput()
      this.unsetFocus()
    },
    changeInput(query = '') {
      this.query = query ? query : ''
      this.$emit('changed', {
        query: this.query
      })
    },
    submit() {
      this.$emit('submitted', {
        query: this.query
      })
    },
    blurSearchInput() {
      this.$refs.searchInput.blur()
    }
  }
}
</script>

<style lang="scss" scoped>
$search-bar-height: 40px;

.search-bar {
  width: 100%;
  display: flex;
  flex-direction: row;
  position: relative;
}

input {
  height: $search-bar-height;
  width: 100%;
  border: 1px solid $black;
  font-size: 13px;
  font-weight: 300;
  letter-spacing: 0.3px;
  padding-left: 10px;
  padding-right: 20px;
  border-radius: 0;
  outline: none;

  &:focus {
    border-radius: 0;
    outline: none;
  }

  @include mobile {
    font-size: 16px;
  }
}

.close-button {
  height: 35px;
  width: 35px;
  background-color: transparent;
  background-image: url('./assets/images/close-icon.svg');
  background-position: center;
  background-repeat: no-repeat;
  border: none;
  position: absolute;
  right: 5px;
  top: 3px;

  @include tablet {
    right: 45px;
  }

  @include mobile {
    height: $search-bar-height;
    width: $search-bar-height;
    background-image: url('./assets/images/close-white-icon.svg');
    background-color: $black;
    top: 0;
    right: 0;
  }
}

.search-button {
  height: $search-bar-height;
  width: 43px;
  display: block;
  background-color: $black;
  background-image: url('./assets/images/search-icon.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 18px;
  border: none;
}
</style>
